export { default } from './Ellipsis';
export { extractEllipsisProps } from './EllipsisUtils';
